/* POKECASED — global theme JS */

(function () {
  // Hold-to-repeat for +/- buttons: fires `action` on pointerdown, then keeps
  // firing every ~80ms after a 400ms initial delay until the pointer is
  // released (anywhere — window listeners survive DOM re-renders, so the
  // optimistic cart re-render mid-hold doesn't break the loop).
  function holdRepeat(button, action) {
    var holdTimer = null;
    var repeatTimer = null;
    function stop() {
      clearTimeout(holdTimer); holdTimer = null;
      clearInterval(repeatTimer); repeatTimer = null;
      window.removeEventListener('pointerup', stop);
      window.removeEventListener('pointercancel', stop);
    }
    button.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      e.preventDefault();
      action();
      // 500ms initial delay, then ~7.5 ticks/sec while held.
      holdTimer = setTimeout(function () {
        repeatTimer = setInterval(action, 130);
      }, 500);
      window.addEventListener('pointerup', stop);
      window.addEventListener('pointercancel', stop);
    });
  }
  window.__pcHoldRepeat = holdRepeat;

  // Color-cycling logo mark. Cycles every 1600ms via background-color swap;
  // CSS handles the 1600ms ease-in-out transition for the fade.
  var LOGO_CYCLE_COLORS = [
    '#0a0a0a', // ink
    '#D93636', // red
    '#E58A2D', // amber
    '#2E5D3B', // forest
    '#3B5998', // indigo
    '#B88843', // brass
    '#8A3FB5'  // violet
  ];
  var LOGO_CYCLE_INTERVAL = 1600;

  // Color-cycling effect intentionally disabled — header logo stays black.
  function startLogoCycle() {}

  // ----------------------------------------------------------
  // Hero acrylic case — drag to rotate; auto-sway when idle.
  // Ported from shared.jsx HeroCase().
  // ----------------------------------------------------------
  function initHeroCases() {
    document.querySelectorAll('[data-pc-hero-case]').forEach(initOneHeroCase);
  }

  function initOneHeroCase(root) {
    var box = root.querySelector('.pc-hero-case__box');
    if (!box) return;

    var angle = -18;
    var dragging = false;
    var startX = 0;
    var startAngle = 0;
    var raf = null;
    var t0 = performance.now();

    function applyTransform() {
      box.style.transform = 'rotateY(' + angle + 'deg) rotateX(-4deg)';
    }

    function tick() {
      if (dragging) { raf = null; return; }
      var dt = (performance.now() - t0) / 1000;
      angle = -18 + Math.sin(dt * 0.4) * 16;
      applyTransform();
      raf = requestAnimationFrame(tick);
    }

    function startTick() {
      if (raf) return;
      t0 = performance.now();
      raf = requestAnimationFrame(tick);
    }
    function stopTick() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }

    function pointerX(e) {
      if (e.clientX != null) return e.clientX;
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      return 0;
    }

    function onMove(e) {
      if (!dragging) return;
      angle = startAngle + (pointerX(e) - startX) * 0.5;
      applyTransform();
    }
    function onUp() {
      if (!dragging) return;
      dragging = false;
      root.setAttribute('data-dragging', 'false');
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      startTick();
    }
    function onDown(e) {
      dragging = true;
      root.setAttribute('data-dragging', 'true');
      startX = pointerX(e);
      startAngle = angle;
      stopTick();
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('touchend', onUp);
    }

    root.addEventListener('mousedown', onDown);
    root.addEventListener('touchstart', onDown, { passive: true });

    applyTransform();
    startTick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCases);
  } else {
    initHeroCases();
  }

  // ----------------------------------------------------------
  // 360° Turntable — drag-to-rotate, scrubs through pre-rendered
  // PNG frames. Ported from shared.jsx TurntableBox.
  // ----------------------------------------------------------
  function initTurntables() {
    document.querySelectorAll('[data-pc-turntable]').forEach(initOneTurntable);
  }

  function initOneTurntable(root) {
    var viewport = root.querySelector('.pc-turntable__viewport');
    var frames = Array.prototype.slice.call(root.querySelectorAll('.pc-turntable__frame'));
    var resetBtn = root.querySelector('[data-pc-turntable-reset]');
    if (!viewport || !frames.length) return;

    var frameCount = parseInt(root.getAttribute('data-frame-count'), 10) || frames.length;
    var clickToReset = root.getAttribute('data-click-to-reset') === 'true';
    var uniformScale = parseFloat(root.getAttribute('data-scale'));
    if (isNaN(uniformScale)) uniformScale = 1.0;
    var translateY = parseFloat(root.getAttribute('data-translate-y'));
    if (isNaN(translateY)) translateY = 0;
    var singleImg = root.getAttribute('data-single-img') === 'true';

    var frameScales = null;
    var scalesAttr = root.getAttribute('data-frame-scales');
    if (scalesAttr) {
      frameScales = scalesAttr.split(',').map(function (s) { return parseFloat(s); });
    }

    // Single-img mode: one <img> in the DOM, JS swaps its `src` on drag.
    // URL list is emitted as a JSON <script> sibling so JS can preload all
    // frames into the browser's image cache once, then swap cheaply.
    var singleFrameUrls = null;
    var singleImgEl = null;
    if (singleImg) {
      var urlsScript = root.querySelector('[data-pc-frame-urls]');
      if (urlsScript) {
        try { singleFrameUrls = JSON.parse(urlsScript.textContent || urlsScript.innerText); }
        catch (e) { singleFrameUrls = null; }
      }
      singleImgEl = frames[0];
    }

    var currentIdx = 0;
    var dragging = false;
    var dragState = { startX: 0, startIdx: 0, fullSpinPx: 600, didDrag: false };

    // Per-frame transform: ETB-style frameScales override the uniform scale,
    // otherwise apply the uniform scale + translate_y to every frame.
    function frameTransform(idx) {
      var s;
      if (frameScales && frameScales[idx] != null && !isNaN(frameScales[idx])) {
        s = frameScales[idx];
      } else {
        s = uniformScale;
      }
      return 'scale(' + s + ') translateY(' + translateY + 'px)';
    }

    // Only the ACTIVE frame carries a `transform` — applying a transform
    // promotes an element to its own GPU compositor layer, so applying it
    // to all 38 frames was creating 38 layers per turntable × 7 turntables
    // = 266+ layers, which the compositor stalls on during fast drags
    // (causing the sticky header to flicker). Putting transform only on
    // the active frame keeps it to ~1 layer per turntable.
    frames[0].style.transform = frameTransform(0);

    // Single-img mode: preload all frame URLs into the browser image cache
    // by calling new Image() so subsequent src swaps are instant.
    if (singleImg && singleFrameUrls) {
      singleFrameUrls.forEach(function (url) { var im = new Image(); im.src = url; });
    }

    function setFrame(next) {
      next = ((next % frameCount) + frameCount) % frameCount;
      if (next === currentIdx) return;

      if (singleImg && singleImgEl && singleFrameUrls) {
        // Nuclear mode — single img, swap its src + transform.
        singleImgEl.style.transform = frameTransform(next);
        singleImgEl.src = singleFrameUrls[next];
        currentIdx = next;
        updateResetBtn();
        return;
      }

      // Stacked mode — toggle which of the N img layers is active, and
      // move the transform OFF the old frame and ONTO the new.
      var prev = frames[currentIdx];
      var nextEl = frames[next];
      nextEl.style.transform = frameTransform(next);
      nextEl.classList.add('is-active');
      prev.classList.remove('is-active');
      prev.style.transform = '';
      currentIdx = next;
      updateResetBtn();
    }

    function updateResetBtn() {
      if (!resetBtn) return;
      resetBtn.disabled = (currentIdx === 0);
    }

    // Frame loading: only frame 0 has `src` set in Liquid; others have
    // `data-src`. Promote data-src → src on idle so initial page render
    // isn't blocked by all 38-79 frames per turntable. Also fires on first
    // pointerdown so the drag never sees an unloaded frame. In single-img
    // mode there's nothing to promote (preloaded via new Image() above).
    var framesPromoted = false;
    function promoteFrames() {
      if (framesPromoted || singleImg) return;
      framesPromoted = true;
      frames.forEach(function (f) {
        var dataSrc = f.getAttribute('data-src');
        if (dataSrc && !f.getAttribute('src')) {
          f.setAttribute('src', dataSrc);
        }
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(promoteFrames, { timeout: 1500 });
    } else {
      setTimeout(promoteFrames, 800);
    }
    // Also preload as soon as the user hovers the card — gives the frames
    // a head start to download before the user starts dragging fast.
    viewport.addEventListener('mouseenter', promoteFrames, { once: true });
    viewport.addEventListener('touchstart', promoteFrames, { once: true, passive: true });

    // rAF-throttled drag: pointermove can fire 120+/sec on high-DPI mice
    // and trackpads. Throttling to once per repaint (60Hz) cuts setFrame
    // calls in half or more while still feeling instantaneous.
    var rafId = null;
    var lastMoveX = 0;
    function onPointerMove(e) {
      if (!dragging) return;
      lastMoveX = e.clientX;
      if (Math.abs(lastMoveX - dragState.startX) > 3) dragState.didDrag = true;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        if (!dragging) return;
        var dx = lastMoveX - dragState.startX;
        var framesDelta = (dx / dragState.fullSpinPx) * frameCount;
        var next = Math.round(dragState.startIdx + framesDelta);
        setFrame(next);
      });
    }
    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      viewport.setAttribute('data-dragging', 'false');
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }
    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      promoteFrames(); // ensure all frames have src before user starts scrubbing
      var rect = viewport.getBoundingClientRect();
      dragState.startX = e.clientX;
      dragState.startIdx = currentIdx;
      dragState.fullSpinPx = rect.width * 1.1;
      dragState.didDrag = false;
      dragging = true;
      viewport.setAttribute('data-dragging', 'true');
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    }

    // Click-capture: swallow click if it followed a real drag (so the wrapping
    // <a> doesn't navigate). On the PDP, also map a static click → reset.
    function onClickCapture(e) {
      if (dragState.didDrag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (clickToReset && currentIdx !== 0) {
        e.preventDefault();
        e.stopPropagation();
        setFrame(0);
      }
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('click', onClickCapture, true); // capture phase = JSX onClickCapture
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if (resetBtn) {
      resetBtn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setFrame(0);
      });
    }

    // Animate rotation back to frame 0 over ~350ms by stepping through frames
    // along the shortest path. Used by the global reset (PDP overlay open +
    // bfcache restore) so the user briefly sees the turntable rewind to rest
    // instead of an instant snap.
    var resetAnim = null;
    function animateReset(durationMs) {
      if (currentIdx === 0) return;
      if (resetAnim) cancelAnimationFrame(resetAnim);
      var startIdx = currentIdx;
      var forwardDist = (frameCount - startIdx) % frameCount;
      var backwardDist = startIdx;
      var dir = (forwardDist < backwardDist) ? 1 : -1;
      var totalSteps = Math.min(forwardDist, backwardDist);
      var startTime = performance.now();
      function step(now) {
        var t = Math.min((now - startTime) / durationMs, 1);
        var eased = 1 - Math.pow(1 - t, 4); // ease-out quart — gentler tail
        var idx = Math.round(startIdx + dir * totalSteps * eased);
        idx = ((idx % frameCount) + frameCount) % frameCount;
        setFrame(idx);
        if (t < 1) {
          resetAnim = requestAnimationFrame(step);
        } else {
          resetAnim = null;
          setFrame(0);
        }
      }
      resetAnim = requestAnimationFrame(step);
    }

    // Global reset on PDP open — skip on PDP turntable (clickToReset=true).
    if (!clickToReset) {
      window.addEventListener('pokecased:reset-turntables', function () { animateReset(650); });

      // Survive real back-nav without bfcache: save current rotation to
      // sessionStorage on pagehide, restore on next load + animate to rest.
      // Keyed by SKU so each card on the homepage remembers its own state.
      var sku = root.getAttribute('data-sku') || '';
      var ssKey = sku ? ('pc-tt-rot:' + sku) : '';
      if (ssKey) {
        window.addEventListener('pagehide', function () {
          try {
            if (currentIdx !== 0) {
              sessionStorage.setItem(ssKey, String(currentIdx));
            } else {
              sessionStorage.removeItem(ssKey);
            }
          } catch (e) {}
        });
        try {
          var savedIdx = parseInt(sessionStorage.getItem(ssKey), 10);
          if (savedIdx && savedIdx > 0 && savedIdx < frameCount) {
            sessionStorage.removeItem(ssKey); // one-shot
            // Jump straight to the saved frame in the same paint so the user
            // sees the rotated state, then rewind to 0 on the next frame.
            setFrame(savedIdx);
            requestAnimationFrame(function () { animateReset(650); });
          }
        } catch (e) {}
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTurntables);
  } else {
    initTurntables();
  }

  // ----------------------------------------------------------
  // PDP CTA block — qty stepper + add-to-bag flash.
  // Ported from components/pdp.jsx ProductDetailPage (qty + handleAdd).
  // Actual cart integration fires `pokecased:add-to-bag` for Screen #10
  // to handle (cart drawer / Shopify cart API).
  // ----------------------------------------------------------
  function initPDPCTAs() {
    document.querySelectorAll('[data-pc-pdp-cta]').forEach(initOnePDPCTA);
  }

  function initOnePDPCTA(root) {
    var dec = root.querySelector('[data-pc-qty-decrement]');
    var inc = root.querySelector('[data-pc-qty-increment]');
    var input = root.querySelector('[data-pc-qty-input]');
    var addBtn = root.querySelector('[data-pc-add-to-bag]');
    if (!dec || !inc || !input || !addBtn) return;

    var priceEl = addBtn.querySelector('.pc-pdp__add-price');
    var labelEl = addBtn.querySelector('.pc-pdp__add-label');
    var basePrice = parseFloat(addBtn.getAttribute('data-product-price'));
    if (isNaN(basePrice)) basePrice = 0;
    var productId = addBtn.getAttribute('data-product-id');

    var added = false;
    var addedTimer = null;

    // PDP qty is hard-capped at the product's current inventory (snapshotted
    // by Liquid at page load). Falls back to 999 if Shopify isn't tracking
    // inventory for this variant.
    var maxQty = (window.__pcInventoryFor && productId) ? window.__pcInventoryFor(productId) : 999;
    if (!maxQty || maxQty < 1) maxQty = 999;

    function readQty() {
      var raw = input.value.replace(/[^0-9]/g, '');
      if (raw === '') return null;
      var n = parseInt(raw, 10);
      if (isNaN(n)) return null;
      return Math.min(maxQty, Math.max(1, n));
    }

    function setQty(value) {
      input.value = String(value);
      updatePrice();
    }

    function updatePrice() {
      if (added || !priceEl) return;
      var q = readQty();
      if (q == null) q = 1;
      priceEl.textContent = '$' + (basePrice * q) + '.00';
    }

    function enterAddedState() {
      added = true;
      addBtn.setAttribute('data-added', 'true');
      if (labelEl) labelEl.textContent = '✓  ADDED TO BAG';
      if (priceEl) priceEl.style.display = 'none';
    }

    function exitAddedState() {
      added = false;
      addBtn.setAttribute('data-added', 'false');
      if (labelEl) labelEl.textContent = 'ADD TO BAG';
      if (priceEl) priceEl.style.display = '';
      updatePrice();
    }

    window.__pcHoldRepeat(dec, function () {
      var q = readQty();
      if (q == null) q = 1;
      setQty(Math.max(1, q - 1));
    });

    window.__pcHoldRepeat(inc, function () {
      var q = readQty();
      if (q == null) q = 0;
      setQty(Math.min(maxQty, q + 1));
    });

    input.addEventListener('input', function (e) {
      var raw = e.target.value.replace(/[^0-9]/g, '');
      if (raw === '') {
        // Allow empty — only snap back on blur (per spec).
        e.target.value = '';
      } else {
        var n = parseInt(raw, 10);
        if (isNaN(n)) n = 1;
        n = Math.min(maxQty, Math.max(1, n));
        e.target.value = String(n);
      }
      updatePrice();
    });

    input.addEventListener('blur', function () {
      if (readQty() == null) setQty(1);
    });

    input.addEventListener('focus', function (e) {
      e.target.select();
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var safeQty = readQty();
      if (safeQty == null) safeQty = 1;
      setQty(safeQty);

      enterAddedState();

      // Fire a custom event for Screen #10 (cart drawer) to hook into.
      window.dispatchEvent(new CustomEvent('pokecased:add-to-bag', {
        detail: { productId: productId, qty: safeQty, price: basePrice }
      }));

      // Revert after 1.8s.
      if (addedTimer) clearTimeout(addedTimer);
      addedTimer = setTimeout(exitAddedState, 1800);
    });

    updatePrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDPCTAs);
  } else {
    initPDPCTAs();
  }

  // ----------------------------------------------------------
  // Cart store — POKECASED_CART. Phase 2: thin async wrapper around
  // Shopify's Cart AJAX API (/cart.js, /cart/add.js, /cart/change.js,
  // /cart/clear.js). Same public interface as the Phase-1 localStorage
  // pub/sub so drawer + cart page render code keeps working.
  // ----------------------------------------------------------
  (function initCartStore() {
    var cart = null; // populated by initial /cart.js fetch
    var listeners = new Set();

    function emit() {
      listeners.forEach(function (fn) { try { fn(cart); } catch (e) {} });
    }
    function findProduct(handle) {
      return (window.POKECASED_PRODUCTS || []).find(function (p) { return p.id === handle; });
    }
    function variantIdFor(handle) {
      var p = findProduct(handle);
      return p ? p.variantId : null;
    }
    // Inventory ceiling for a product (page-load snapshot from Shopify). Falls
    // back to 999 if the variant doesn't have inventory tracking enabled —
    // that way "continue selling" / unlimited products aren't clamped.
    function inventoryFor(handle) {
      var p = findProduct(handle);
      if (!p || p.inventory == null) return 999;
      var inv = parseInt(p.inventory, 10);
      if (isNaN(inv) || inv < 0) return 999;
      return inv;
    }
    window.__pcInventoryFor = inventoryFor;

    function fetchCart() {
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          // Apply any in-flight overrides so a stale /cart.js response
          // (e.g., from a queued .then(fetchCart) after add) doesn't
          // resurrect items the user just removed. Without this, the UI
          // briefly shows the removed item again until the debounced
          // /cart/change.js commit lands ~240ms later.
          cart = applyServerCartKeepingOverrides(c);
          emit();
          return cart;
        })
        .catch(function (e) { console.warn('[POKECASED_CART] /cart.js failed', e); });
    }
    function postJSON(url, body) {
      // keepalive: true lets the request complete even if the page
      // navigates/refreshes mid-flight. Critical for cart mutations:
      // without it, clicking REMOVE then immediately refreshing would
      // cancel the in-flight POST and the server would still have the
      // item on next page load. Bodies under 64KB are eligible.
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error(url + ' returned ' + r.status + ' — ' + (data.description || data.message || JSON.stringify(data)));
            err.data = data;
            err.status = r.status;
            throw err;
          }
          return data;
        });
      });
    }
    function lineKeyFor(handle) {
      if (!cart || !cart.items) return null;
      var line = cart.items.find(function (it) { return it.handle === handle; });
      return line ? line.key : null;
    }

    // === Rebuilt cart qty model ============================================
    //
    // qtyOverrides is the UI's source of truth during interaction. setQty
    // writes here, render reads from here. Server requests fire in the
    // background but NEVER write back to qtyOverrides — this is what kills
    // the "snap-back" glitch. The pre-checkout sync() (and only that) clears
    // overrides so checkout sees Shopify's authoritative cart.
    //
    // handle -> { qty: number, lastSetAt: timestamp }
    var qtyOverrides = {};
    var commitTimers = {};   // per-handle debounce timer
    var flightPromise = Promise.resolve();

    function setDisplayQty(handle, qty) {
      qtyOverrides[handle] = { qty: qty, lastSetAt: Date.now() };
      // Mirror into cart.items so renderers reading from the cart object see
      // the override immediately. Server responses won't undo this.
      if (cart && cart.items) {
        var found = false;
        cart.items = cart.items
          .map(function (it) {
            if (it.handle !== handle) return it;
            found = true;
            var unit = it.final_price != null ? it.final_price : it.price;
            return Object.assign({}, it, {
              quantity: qty,
              line_price: unit * qty,
              final_line_price: unit * qty,
              original_line_price: (it.original_price != null ? it.original_price : unit) * qty
            });
          })
          .filter(function (it) { return it.quantity > 0; });
        if (found || qty === 0) {
          cart.item_count = cart.items.reduce(function (s, it) { return s + it.quantity; }, 0);
          cart.total_price = cart.items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price); }, 0);
        }
        emit();
      }
    }

    function scheduleServerCommit(handle) {
      clearTimeout(commitTimers[handle]);
      commitTimers[handle] = setTimeout(function () {
        commitTimers[handle] = null;
        commitOne(handle);
      }, 240);
    }

    function commitOne(handle, preferredKey) {
      var target = qtyOverrides[handle];
      if (!target) return Promise.resolve();
      // Shopify's /cart/change.js endpoint REQUIRES a line item key
      // (format: "<variant>:<32 hex>") or a 1-based line index. It
      // does NOT accept a bare variant ID — that returns 400 "expected
      // Integer to be a (?-mix:...)". The variant ID fallback is only
      // useful for /cart/add.js, which is more permissive.
      //
      // The caller (setQty) captures the line key BEFORE setDisplayQty
      // filters the zero-qty item out of cart.items, and passes it as
      // `preferredKey`. By the time we reach commitOne, lineKeyFor()
      // would return null because the item has already been removed
      // from the local cart state.
      var idParam = preferredKey || lineKeyFor(handle) || variantIdFor(handle);
      if (!idParam) return Promise.resolve();
      var qty = target.qty;
      flightPromise = flightPromise.then(function () {
        return postJSON('/cart/change.js', { id: idParam, quantity: qty })
          .then(function (newCart) {
            // If the user changed qty again while this commit was in
            // flight, leave the override in place so the next scheduled
            // commit picks up the latest intent. Otherwise clear it —
            // the server now has the canonical value and a lingering
            // override would zero out future state (e.g., a stale
            // "qty=0" override would silently undo a subsequent add).
            if (qtyOverrides[handle] && qtyOverrides[handle].qty === qty) {
              delete qtyOverrides[handle];
            }
            if (newCart) cart = applyServerCartKeepingOverrides(newCart);
            emit();
          })
          .catch(function (err) {
            console.error('[POKECASED_CART] commitOne failed:', err);
            // Don't fetchCart here — that would clear overrides during
            // interaction. We'll reconcile at the next sync().
          });
      });
      return flightPromise;
    }

    function applyServerCartKeepingOverrides(serverCart) {
      // Take the server's cart but for any handle we have an override on,
      // keep the override's quantity in the line item. Also drop any line
      // whose override pinned it to 0 — otherwise a stale /cart.js fetch
      // would resurrect a just-removed item until the debounced
      // /cart/change.js commit lands.
      if (!serverCart || !serverCart.items) return serverCart;
      var anyOverride = false;
      serverCart.items = serverCart.items
        .map(function (it) {
          var ov = qtyOverrides[it.handle];
          if (!ov) return it;
          anyOverride = true;
          var unit = it.final_price != null ? it.final_price : it.price;
          return Object.assign({}, it, {
            quantity: ov.qty,
            line_price: unit * ov.qty,
            final_line_price: unit * ov.qty,
            original_line_price: (it.original_price != null ? it.original_price : unit) * ov.qty
          });
        })
        .filter(function (it) { return it.quantity > 0; });
      if (anyOverride) {
        serverCart.item_count = serverCart.items.reduce(function (s, it) { return s + it.quantity; }, 0);
        serverCart.total_price = serverCart.items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price); }, 0);
      }
      return serverCart;
    }

    function flushPending() {
      // Force-commit every pending change and clear overrides so the next
      // /cart.js fetch can fully reconcile (e.g., right before checkout).
      var handles = Object.keys(qtyOverrides);
      var p = flightPromise;
      handles.forEach(function (h) {
        // Cancel pending debounce and commit immediately
        if (commitTimers[h]) {
          clearTimeout(commitTimers[h]);
          commitTimers[h] = null;
        }
        p = p.then(function () { return commitOne(h); });
      });
      // After all commits, drop overrides and refetch authoritative state.
      p = p.then(function () {
        qtyOverrides = {};
        return fetchCart();
      });
      flightPromise = p;
      return p;
    }

    window.POKECASED_CART = {
      // Items are normalized to the shape the renderers expect:
      // { id: <handle>, qty, variantId, key, line_price }
      getItems: function () {
        if (!cart) return [];
        return cart.items.map(function (it) {
          return {
            id: it.handle,
            qty: it.quantity,
            variantId: it.variant_id,
            key: it.key,
            linePrice: it.line_price
          };
        });
      },
      getCount: function () { return cart ? cart.item_count : 0; },
      // Returns dollars (whole units) for display math compatibility.
      getSubtotal: function () { return cart ? Math.round(cart.total_price / 100) : 0; },

      add: function (handle, qty) {
        var vid = variantIdFor(handle);
        if (!vid) return Promise.reject(new Error('Unknown product: ' + handle));
        // User explicitly wants to add. Clear any pending override for
        // this handle — most importantly a stale "qty=0" from a recent
        // remove that hasn't been GC'd yet, which would otherwise zero
        // out the server response in fetchCart and silently undo the add.
        delete qtyOverrides[handle];
        if (commitTimers[handle]) {
          clearTimeout(commitTimers[handle]);
          commitTimers[handle] = null;
        }
        // Cap at inventory: existing cart qty + requested add must not exceed
        // Shopify's tracked stock for this variant.
        var inv = inventoryFor(handle);
        var existingQty = 0;
        if (cart && cart.items) {
          var existingLine = cart.items.find(function (it) { return it.handle === handle; });
          if (existingLine) existingQty = existingLine.quantity;
        }
        var maxAddable = Math.max(0, inv - existingQty);
        var addQty = Math.min(qty || 1, maxAddable);
        if (addQty <= 0) {
          // Nothing can be added — already at cap.
          return Promise.resolve();
        }

        // NO optimistic update. The add waits for /cart/add.js to land
        // on the server, then fetchCart, then emit. ~200ms slower on
        // the ADD click, but it eliminates the race that caused removed
        // items to come back: with optimistic add, the cart drawer
        // would show the item before the server had committed it, so a
        // subsequent REMOVE could race ahead of the add on the server
        // (especially under unload via keepalive/sendBeacon where
        // request ordering isn't guaranteed). With server-confirmed
        // add, by the time the drawer renders the item, the server has
        // it for sure — and REMOVE always operates on real state.
        flightPromise = flightPromise.then(function () {
          return postJSON('/cart/add.js', { id: vid, quantity: addQty })
            .then(fetchCart)
            .catch(function (err) {
              console.error('[POKECASED_CART] add failed:', err);
              return fetchCart();
            });
        });
        return flightPromise;
      },
      setQty: function (handle, qty) {
        var newQty = Math.max(0, Math.min(qty, inventoryFor(handle)));
        // Capture the line item key BEFORE setDisplayQty filters the
        // zero-qty item out of cart.items. /cart/change.js requires
        // the line key (or 1-based index) — sending the variant ID
        // returns 400 Bad Request.
        var cachedLineKey = newQty === 0 ? lineKeyFor(handle) : null;
        setDisplayQty(handle, newQty);
        // Removals (qty=0) commit immediately so a quick refresh or
        // page nav can't lose them. Debounce is only useful for rapid
        // +/- hold-to-repeat, never for a one-shot removal click.
        if (newQty === 0) {
          if (commitTimers[handle]) {
            clearTimeout(commitTimers[handle]);
            commitTimers[handle] = null;
          }
          return commitOne(handle, cachedLineKey);
        }
        scheduleServerCommit(handle);
        return Promise.resolve();
      },
      remove: function (handle) {
        return this.setQty(handle, 0);
      },
      clear: function () {
        return postJSON('/cart/clear.js', {}).then(fetchCart);
      },
      subscribe: function (fn) {
        listeners.add(fn);
        return function () { listeners.delete(fn); };
      },
      refresh: fetchCart,
      // Force-commit any pending debounced qty changes and wait for Shopify
      // to confirm. Call before navigating to /checkout so the server cart
      // reflects the latest UI state.
      sync: function () { return flushPending(); }
    };

    // Hydrate cart from Shopify on page load. Once it resolves, drawer
    // and cart-page subscribers fire with real state.
    fetchCart();

    // Flush any pending qty changes when the page is unloading. Without
    // this, a debounced remove (240ms) can be lost if the user clicks a
    // product link before the timer fires — the new page then loads with
    // the "removed" item still in the server cart, making it look like
    // removed items resurrect themselves. sendBeacon is the only request
    // type browsers reliably deliver during page unload.
    function flushPendingViaBeacon() {
      if (!navigator.sendBeacon) return;
      var handles = Object.keys(qtyOverrides);
      handles.forEach(function (h) {
        var target = qtyOverrides[h];
        if (!target) return;
        var idParam = lineKeyFor(h) || variantIdFor(h);
        if (!idParam) return;
        if (commitTimers[h]) {
          clearTimeout(commitTimers[h]);
          commitTimers[h] = null;
        }
        try {
          // JSON Blob (not FormData/multipart) — Shopify's /cart/change.js
          // parses JSON reliably; multipart parsing on this endpoint is
          // hit-or-miss and was the reason the previous beacon attempt
          // failed silently. Same payload shape postJSON sends.
          var blob = new Blob(
            [JSON.stringify({ id: idParam, quantity: target.qty })],
            { type: 'application/json' }
          );
          navigator.sendBeacon('/cart/change.js', blob);
        } catch (e) {
          // Best-effort only — page is unloading.
        }
      });
    }
    // `pagehide` is more reliable than `beforeunload` (fires on
    // back/forward navigation, mobile, and bfcache transitions).
    window.addEventListener('pagehide', flushPendingViaBeacon);
    // Belt-and-suspenders: also flush when tab becomes hidden, which
    // catches some cases pagehide misses on mobile.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushPendingViaBeacon();
    });

    // Back-forward cache (bfcache) restoration handler. When a user
    // navigates back/forward (or in modern Chrome, even forward to a
    // recently-visited URL), the browser may restore the entire page
    // from cache — DOM, JavaScript heap, and all. Our IIFE doesn't
    // re-run, so the cart state stays frozen at whatever it was when
    // the page was cached. This means a freshly-removed item appears
    // to "come back" because we never re-fetched /cart.js.
    //
    // pageshow with event.persisted === true is the canonical signal
    // for bfcache restoration. Force a re-fetch so the cart reflects
    // the current server state.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        qtyOverrides = {};
        fetchCart();
      }
    });
  })();

  // ----------------------------------------------------------
  // Cart drawer — slide-in panel from the right. Ported from
  // components/cart.jsx CartDrawer.
  // ----------------------------------------------------------
  function initCartDrawer() {
    var root = document.querySelector('[data-pc-cart-root]');
    if (!root) return;

    var itemsEl = root.querySelector('[data-pc-cart-items]');
    var emptyEl = root.querySelector('[data-pc-cart-empty]');
    var countEl = root.querySelector('[data-pc-cart-count]');
    var footerEl = root.querySelector('[data-pc-cart-footer]');
    var subtotalEl = root.querySelector('[data-pc-cart-subtotal]');
    var shippingEl = root.querySelector('[data-pc-cart-shipping]');
    var checkoutAmountEl = root.querySelector('[data-pc-cart-checkout-amount]');
    var checkoutBtn = root.querySelector('[data-pc-cart-checkout]');

    var isOpen = false;

    function open() {
      isOpen = true;
      root.setAttribute('data-open', 'true');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      isOpen = false;
      root.setAttribute('data-open', 'false');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-pc-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    document.querySelectorAll('[data-pc-open-cart]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Bridge: PDP ADD TO BAG → Shopify cart + open drawer after add resolves.
    // Wait for the /cart/add.js round-trip so the drawer renders the line.
    window.addEventListener('pokecased:add-to-bag', function (e) {
      var detail = e.detail || {};
      if (!detail.productId) return;
      window.POKECASED_CART.add(detail.productId, detail.qty || 1)
        .then(function () { setTimeout(open, 350); })
        .catch(function (err) { console.warn('Add to bag failed:', err); });
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Flush any debounced qty changes before navigating so the
        // Shopify checkout page sees the latest cart state.
        checkoutBtn.setAttribute('disabled', '');
        window.POKECASED_CART.sync().then(function () {
          window.location.href = '/checkout';
        });
      });
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
      });
    }

    var hasLoadedOnce = false;
    function render() {
      var Cart = window.POKECASED_CART;
      var items = Cart.getItems();
      var count = Cart.getCount();
      var subtotal = Cart.getSubtotal();
      var products = window.POKECASED_PRODUCTS || [];

      // Don't overwrite the server-rendered Bag (N) in the header until
      // /cart.js has resolved at least once — otherwise the count flashes
      // to 0 on every page load between init and fetchCart's promise.
      if (hasLoadedOnce) {
        if (countEl) countEl.textContent = count + (count === 1 ? ' ITEM' : ' ITEMS');
        document.querySelectorAll('[data-pc-cart-count-display]').forEach(function (el) {
          el.textContent = String(count);
        });
      }

      if (items.length === 0) {
        emptyEl.hidden = false;
        itemsEl.hidden = true;
        footerEl.hidden = true;
        return;
      }

      // FAST PATH: if the SAME set of item ids is already rendered (just qty
      // changes), update qty inputs + line totals in place instead of
      // rebuilding the whole HTML. Avoids the layout flicker on hold-to-repeat.
      var existingRows = Array.prototype.slice.call(itemsEl.querySelectorAll('.pc-cart-item'));
      var existingIds = existingRows.map(function (r) { return r.getAttribute('data-id'); });
      var newIds = items.map(function (it) { return it.id; });
      var sameSet = existingIds.length === newIds.length &&
                    existingIds.every(function (id, i) { return id === newIds[i]; });
      if (sameSet && existingRows.length > 0) {
        emptyEl.hidden = true;
        itemsEl.hidden = false;
        footerEl.hidden = false;
        items.forEach(function (it, i) {
          var row = existingRows[i];
          var p = products.find(function (pp) { return pp.id === it.id; });
          if (!p) return;
          var qtyInput = row.querySelector('[data-pc-cart-qty]');
          if (qtyInput && qtyInput !== document.activeElement) {
            qtyInput.value = String(it.qty);
          }
          var totalEl = row.querySelector('.pc-cart-item__total');
          if (totalEl) totalEl.textContent = '$' + (p.price * it.qty);
          var eachEl = row.querySelector('.pc-cart-item__each');
          if (it.qty > 1) {
            if (!eachEl) {
              var newEach = document.createElement('div');
              newEach.className = 'pc-cart-item__each';
              newEach.textContent = '$' + p.price + ' EACH';
              var removeBtn = row.querySelector('.pc-cart-item__remove');
              if (removeBtn) removeBtn.parentNode.insertBefore(newEach, removeBtn);
            } else {
              eachEl.textContent = '$' + p.price + ' EACH';
            }
          } else if (eachEl) {
            eachEl.parentNode.removeChild(eachEl);
          }
        });
        subtotalEl.textContent = '$' + subtotal;
        checkoutAmountEl.textContent = '$' + subtotal;
        if (subtotal >= 75) {
          shippingEl.textContent = 'FREE SHIPPING UNLOCKED ✓';
        } else {
          shippingEl.textContent = 'ADD $' + (75 - subtotal) + ' FOR FREE SHIPPING';
        }
        return;
      }

      emptyEl.hidden = true;
      itemsEl.hidden = false;
      footerEl.hidden = false;

      itemsEl.innerHTML = items.map(function (it) {
        var p = products.find(function (pp) { return pp.id === it.id; });
        if (!p) return '';
        var lineTotal = p.price * it.qty;
        var eachRow = it.qty > 1
          ? '<div class="pc-cart-item__each">$' + p.price + ' EACH</div>'
          : '';
        var pdpUrl = '/products/' + p.id;
        return '' +
          '<div class="pc-cart-item" data-id="' + p.id + '">' +
            '<a class="pc-cart-item__overlay" href="' + pdpUrl + '" aria-label="View ' + escapeHtml(p.name) + '"></a>' +
            '<div class="pc-cart-item__thumb">' +
              '<img src="' + p.thumb + '" alt="' + escapeHtml(p.name) + '" style="transform: scale(' + (p.thumbScale || 1) + ');" />' +
            '</div>' +
            '<div class="pc-cart-item__info">' +
              '<div class="pc-cart-item__brand">' + escapeHtml(p.brand.toUpperCase()) + '</div>' +
              '<div class="pc-cart-item__name">' + escapeHtml(p.name) + '</div>' +
              '<div class="pc-cart-item__sub">ACRYLIC CASE</div>' +
              '<div class="pc-cart-item__qty">' +
                '<button type="button" data-pc-cart-dec aria-label="Decrease quantity">&minus;</button>' +
                '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + it.qty + '" aria-label="Quantity" data-pc-cart-qty />' +
                '<button type="button" data-pc-cart-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="pc-cart-item__right">' +
              '<div class="pc-cart-item__total">$' + lineTotal + '</div>' +
              eachRow +
              '<button type="button" class="pc-cart-item__remove" data-pc-cart-remove>REMOVE</button>' +
            '</div>' +
          '</div>';
      }).join('');

      // Wire per-item controls
      itemsEl.querySelectorAll('.pc-cart-item').forEach(function (itemEl) {
        var id = itemEl.getAttribute('data-id');
        var item = items.find(function (it) { return it.id === id; });
        if (!item) return;

        // Hold-to-repeat: each step reads the live qty from the cart so the
        // increment applies on top of prior optimistic updates, not the qty
        // captured at render time. The "−" button bottoms out at 1 — to
        // remove an item, the user clicks REMOVE.
        window.__pcHoldRepeat(itemEl.querySelector('[data-pc-cart-dec]'), function () {
          var live = window.POKECASED_CART.getItems().find(function (i) { return i.id === id; });
          if (!live || live.qty <= 1) return;
          window.POKECASED_CART.setQty(id, live.qty - 1);
        });
        window.__pcHoldRepeat(itemEl.querySelector('[data-pc-cart-inc]'), function () {
          var live = window.POKECASED_CART.getItems().find(function (i) { return i.id === id; });
          if (!live) return;
          var cap = window.__pcInventoryFor ? window.__pcInventoryFor(id) : 999;
          if (live.qty >= cap) return;
          window.POKECASED_CART.setQty(id, Math.min(cap, live.qty + 1));
        });
        itemEl.querySelector('[data-pc-cart-remove]').addEventListener('click', function () {
          window.POKECASED_CART.remove(id);
        });

        var qtyInput = itemEl.querySelector('[data-pc-cart-qty]');
        var draft = String(item.qty);
        // Commit to Shopify on BLUR only (not on every keystroke). With the
        // real Cart API every commit is a network call + a full re-render,
        // which would kill the input's focus mid-edit.
        qtyInput.addEventListener('input', function (e) {
          var raw = e.target.value.replace(/[^0-9]/g, '');
          draft = raw;
          e.target.value = raw;
        });
        qtyInput.addEventListener('blur', function (e) {
          if (draft === '' || parseInt(draft, 10) < 1) {
            e.target.value = '1';
            draft = '1';
            window.POKECASED_CART.setQty(id, 1);
          } else {
            var n = Math.min(999, Math.max(1, parseInt(draft, 10)));
            if (n !== item.qty) window.POKECASED_CART.setQty(id, n);
          }
        });
        qtyInput.addEventListener('focus', function (e) { e.target.select(); });
      });

      subtotalEl.textContent = '$' + subtotal;
      checkoutAmountEl.textContent = '$' + subtotal;
      if (subtotal >= 75) {
        shippingEl.textContent = 'FREE SHIPPING UNLOCKED ✓';
      } else {
        shippingEl.textContent = 'ADD $' + (75 - subtotal) + ' FOR FREE SHIPPING';
      }
    }

    // Click-outside-to-commit (drawer-wide): when a qty input is focused and
    // user clicks anywhere in the cart items section (not on the qty input
    // itself), commit the typed value by blurring — and SUPPRESS the click
    // so the row's overlay link doesn't navigate. Second click navigates.
    // mousedown runs before focus shifts, so we capture the focused state
    // there, then suppress the corresponding click.
    var qtyWasFocusedAtMousedown = false;
    itemsEl.addEventListener('mousedown', function (e) {
      var focused = root.querySelector('[data-pc-cart-qty]:focus');
      // Only flag suppression if user clicked OUTSIDE the focused qty input
      qtyWasFocusedAtMousedown = !!focused && !e.target.closest('[data-pc-cart-qty]');
    }, true);
    itemsEl.addEventListener('click', function (e) {
      if (qtyWasFocusedAtMousedown) {
        e.preventDefault();
        e.stopPropagation();
      }
      qtyWasFocusedAtMousedown = false;
    }, true);

    window.POKECASED_CART.subscribe(function (c) {
      if (c) hasLoadedOnce = true;
      render();
    });
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

  // ----------------------------------------------------------
  // Cart page (Screen #11) — full-width rendering of POKECASED_CART
  // at the /cart route. Subscribes to the same store as the drawer.
  // ----------------------------------------------------------
  function initCartPage() {
    var root = document.querySelector('[data-pc-cart-page]');
    if (!root) return;

    var countTextEl = root.querySelector('[data-pc-cart-page-count-text]');
    var emptyEl = root.querySelector('[data-pc-cart-page-empty]');
    var itemsEl = root.querySelector('[data-pc-cart-page-items]');
    var summaryEl = root.querySelector('[data-pc-cart-page-summary]');
    var subtotalEl = root.querySelector('[data-pc-cart-page-subtotal]');
    var shippingEl = root.querySelector('[data-pc-cart-page-shipping]');
    var checkoutAmountEl = root.querySelector('[data-pc-cart-page-checkout-amount]');
    var checkoutBtn = root.querySelector('[data-pc-cart-page-checkout]');

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        checkoutBtn.setAttribute('disabled', '');
        window.POKECASED_CART.sync().then(function () {
          window.location.href = '/checkout';
        });
      });
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
      });
    }

    function render() {
      var Cart = window.POKECASED_CART;
      var items = Cart.getItems();
      var count = Cart.getCount();
      var subtotal = Cart.getSubtotal();
      var products = window.POKECASED_PRODUCTS || [];

      if (countTextEl) {
        countTextEl.textContent = count === 1 ? '1 ITEM' : count + ' ITEMS';
      }

      if (items.length === 0) {
        emptyEl.hidden = false;
        itemsEl.hidden = true;
        summaryEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      itemsEl.hidden = false;
      summaryEl.hidden = false;

      itemsEl.innerHTML = items.map(function (it) {
        var p = products.find(function (pp) { return pp.id === it.id; });
        if (!p) return '';
        var lineTotal = p.price * it.qty;
        var eachRow = it.qty > 1
          ? '<div class="pc-cart-page-item__each">$' + p.price + ' EACH</div>'
          : '';
        return '' +
          '<div class="pc-cart-page-item" data-id="' + p.id + '">' +
            '<div class="pc-cart-page-item__thumb">' +
              '<img src="' + p.thumb + '" alt="' + escapeHtml(p.name) + '" style="transform: scale(' + (p.thumbScale || 1) + ');" />' +
            '</div>' +
            '<div class="pc-cart-page-item__info">' +
              '<div class="pc-cart-page-item__brand">' + escapeHtml(p.brand.toUpperCase()) + '</div>' +
              '<div class="pc-cart-page-item__name">' + escapeHtml(p.name) + '</div>' +
              '<div class="pc-cart-page-item__sub">ACRYLIC CASE</div>' +
              '<div class="pc-cart-page-item__qty">' +
                '<button type="button" data-pc-cart-page-dec aria-label="Decrease quantity">&minus;</button>' +
                '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + it.qty + '" aria-label="Quantity" data-pc-cart-page-qty />' +
                '<button type="button" data-pc-cart-page-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="pc-cart-page-item__right">' +
              '<div class="pc-cart-page-item__total">$' + lineTotal + '</div>' +
              eachRow +
              '<button type="button" class="pc-cart-page-item__remove" data-pc-cart-page-remove>REMOVE</button>' +
            '</div>' +
          '</div>';
      }).join('');

      itemsEl.querySelectorAll('.pc-cart-page-item').forEach(function (itemEl) {
        var id = itemEl.getAttribute('data-id');
        var item = items.find(function (it) { return it.id === id; });
        if (!item) return;

        window.__pcHoldRepeat(itemEl.querySelector('[data-pc-cart-page-dec]'), function () {
          var live = window.POKECASED_CART.getItems().find(function (i) { return i.id === id; });
          if (!live || live.qty <= 1) return;
          window.POKECASED_CART.setQty(id, live.qty - 1);
        });
        window.__pcHoldRepeat(itemEl.querySelector('[data-pc-cart-page-inc]'), function () {
          var live = window.POKECASED_CART.getItems().find(function (i) { return i.id === id; });
          if (!live) return;
          var cap = window.__pcInventoryFor ? window.__pcInventoryFor(id) : 999;
          if (live.qty >= cap) return;
          window.POKECASED_CART.setQty(id, Math.min(cap, live.qty + 1));
        });
        itemEl.querySelector('[data-pc-cart-page-remove]').addEventListener('click', function () {
          window.POKECASED_CART.remove(id);
        });

        var qtyInput = itemEl.querySelector('[data-pc-cart-page-qty]');
        var draft = String(item.qty);
        // Commit on blur only — see drawer for the same rationale.
        qtyInput.addEventListener('input', function (e) {
          var raw = e.target.value.replace(/[^0-9]/g, '');
          draft = raw;
          e.target.value = raw;
        });
        qtyInput.addEventListener('blur', function (e) {
          if (draft === '' || parseInt(draft, 10) < 1) {
            e.target.value = '1';
            draft = '1';
            window.POKECASED_CART.setQty(id, 1);
          } else {
            var n = Math.min(999, Math.max(1, parseInt(draft, 10)));
            if (n !== item.qty) window.POKECASED_CART.setQty(id, n);
          }
        });
        qtyInput.addEventListener('focus', function (e) { e.target.select(); });
      });

      subtotalEl.textContent = '$' + subtotal;
      checkoutAmountEl.textContent = '$' + subtotal;
      if (subtotal >= 75) {
        shippingEl.textContent = 'FREE SHIPPING UNLOCKED ✓';
      } else {
        shippingEl.textContent = 'ADD $' + (75 - subtotal) + ' FOR FREE SHIPPING';
      }
    }

    window.POKECASED_CART.subscribe(render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  // ----------------------------------------------------------
  // Mobile menu (Screen #13) — slide-in side panel triggered
  // by the hamburger button (which is only visible <600px).
  // ----------------------------------------------------------
  function initMobileMenu() {
    var root = document.querySelector('[data-pc-mobile-menu]');
    var openBtn = document.querySelector('[data-pc-menu-open]');
    if (!root || !openBtn) return;

    function open() {
      root.setAttribute('data-open', 'true');
      root.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      root.setAttribute('data-open', 'false');
      root.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    root.querySelectorAll('[data-pc-menu-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
    });

    // Close when a menu link is clicked (so navigation feels right).
    root.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { close(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }

  // ----------------------------------------------------------
  // PDP overlay — open on product card click, close on
  // back / ESC / scrim. Matches the prototype's slide-up modal.
  // ----------------------------------------------------------
  function initPDPOverlay() {
    var overlay = document.querySelector('[data-pc-pdp-overlay]');
    if (!overlay) return;
    var instances = overlay.querySelectorAll('.pc-pdp-instance');

    function openPDP(productId) {
      if (!productId) return;
      var matched = false;
      instances.forEach(function (inst) {
        if (inst.getAttribute('data-product-id') === productId) {
          inst.setAttribute('data-active', '');
          matched = true;
        } else {
          inst.removeAttribute('data-active');
        }
      });
      if (!matched) return;
      overlay.setAttribute('data-open', 'true');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      // Reset homepage turntables behind the overlay so they're back at frame 0
      // next time the user closes the PDP and sees the grid (per spec).
      window.dispatchEvent(new CustomEvent('pokecased:reset-turntables'));
    }
    function closePDP() {
      overlay.setAttribute('data-open', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    overlay.querySelectorAll('[data-pc-pdp-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePDP();
      });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') {
        closePDP();
      }
    });

    // Expose globally so the product-card click handler can call it.
    window.POKECASED_OPEN_PDP = openPDP;
    window.POKECASED_CLOSE_PDP = closePDP;
  }

  // Wire product-card clicks → open the corresponding PDP. The turntable
  // viewport's own clickCapture in capture phase swallows clicks that
  // followed a real drag, so dragging-to-rotate doesn't trigger nav.
  function initProductCardClicks() {
    document.querySelectorAll('[data-pc-product-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var id = card.getAttribute('data-product-id');
        if (window.POKECASED_OPEN_PDP) {
          window.POKECASED_OPEN_PDP(id);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPDPOverlay();
      initProductCardClicks();
    });
  } else {
    initPDPOverlay();
    initProductCardClicks();
  }

  // ----------------------------------------------------------
  // Reset homepage turntables ONLY on return from a PDP (browser
  // back-button / bfcache restore). Per user spec: the rotated state
  // should persist visually through the click → PDP navigation;
  // the reset only happens silently when the user comes back.
  // ----------------------------------------------------------
  function initTurntableResets() {
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        window.dispatchEvent(new CustomEvent('pokecased:reset-turntables'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTurntableResets);
  } else {
    initTurntableResets();
  }

  // ----------------------------------------------------------
  // Collection toolbar — FILTER (brand) + SORT (price/featured).
  // Custom dropdowns (not native <select>) for design consistency.
  // Client-side only: hides non-matching cards via display:none
  // and reorders the grid by re-inserting cards in the new order.
  // ----------------------------------------------------------
  function initCollectionToolbar() {
    var grid = document.querySelector('.pc-collection__grid');
    if (!grid) return;
    var dropdowns = document.querySelectorAll('[data-pc-dropdown]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pc-card'));
    if (!cards.length) return;

    function currentValue(name) {
      var dd = document.querySelector('[data-pc-dropdown="' + name + '"]');
      return dd ? (dd.getAttribute('data-current') || '') : '';
    }

    function apply() {
      var filterVal = currentValue('filter') || 'all';
      var sortVal = currentValue('sort') || 'featured';

      cards.forEach(function (card) {
        var brand = card.getAttribute('data-product-brand') || '';
        var matches = (filterVal === 'all') || (brand === filterVal);
        card.style.display = matches ? '' : 'none';
      });

      var visible = cards.filter(function (c) { return c.style.display !== 'none'; });
      visible.sort(function (a, b) {
        if (sortVal === 'price-desc') {
          return parseFloat(b.getAttribute('data-product-price')) - parseFloat(a.getAttribute('data-product-price'));
        }
        if (sortVal === 'price-asc') {
          return parseFloat(a.getAttribute('data-product-price')) - parseFloat(b.getAttribute('data-product-price'));
        }
        return parseInt(a.getAttribute('data-original-index'), 10) - parseInt(b.getAttribute('data-original-index'), 10);
      });
      visible.forEach(function (card) { grid.appendChild(card); });
    }

    function closeAllDropdowns() {
      dropdowns.forEach(function (dd) {
        dd.setAttribute('data-open', 'false');
        var trigger = dd.querySelector('.pc-dd__trigger');
        var menu = dd.querySelector('.pc-dd__menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
    }

    dropdowns.forEach(function (dd) {
      var trigger = dd.querySelector('.pc-dd__trigger');
      var menu = dd.querySelector('.pc-dd__menu');
      var valueEl = dd.querySelector('.pc-dd__value');
      var options = Array.prototype.slice.call(dd.querySelectorAll('.pc-dd__option'));
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dd.getAttribute('data-open') === 'true';
        closeAllDropdowns();
        if (!isOpen) {
          dd.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
      });

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var newValue = opt.getAttribute('data-value');
          dd.setAttribute('data-current', newValue);
          if (valueEl) valueEl.textContent = opt.textContent.trim();
          options.forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-selected', 'true');
          closeAllDropdowns();
          apply();
        });
      });
    });

    // Click outside / Escape closes any open dropdown.
    document.addEventListener('click', function (e) {
      var openDd = document.querySelector('[data-pc-dropdown][data-open="true"]');
      if (!openDd) return;
      if (!openDd.contains(e.target)) closeAllDropdowns();
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionToolbar);
  } else {
    initCollectionToolbar();
  }

  // ----------------------------------------------------------
  // Search overlay — client-side filter over POKECASED_PRODUCTS
  // matching name + brand + tags. Renders results live as the user
  // types. Triggered by any [data-pc-search-open] button.
  // ----------------------------------------------------------
  function initSearch() {
    var root = document.querySelector('[data-pc-search-root]');
    if (!root) return;
    var input = root.querySelector('[data-pc-search-input]');
    var resultsEl = root.querySelector('[data-pc-search-results]');
    if (!input || !resultsEl) return;

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
      });
    }

    function open() {
      root.setAttribute('data-open', 'true');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      root.setAttribute('data-open', 'false');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      input.value = '';
      render();
    }

    document.querySelectorAll('[data-pc-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    root.querySelectorAll('[data-pc-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
    });

    function render() {
      var query = (input.value || '').toLowerCase().trim();
      var products = window.POKECASED_PRODUCTS || [];

      if (!query) {
        resultsEl.innerHTML = '<div class="pc-search__hint">Start typing to search products&hellip;</div>';
        return;
      }

      var matches = products.filter(function (p) {
        var hay = (p.name + ' ' + p.brand + ' ' + ((p.tags || []).join(' '))).toLowerCase();
        return hay.indexOf(query) !== -1;
      });

      if (matches.length === 0) {
        resultsEl.innerHTML = '<div class="pc-search__empty">No matches for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
        return;
      }

      resultsEl.innerHTML = matches.map(function (p) {
        var pillBg = p.brand === 'Pokémon' ? '#F18A8A' : (p.brand === 'One Piece' ? '#7AC5D1' : '#0a0a0a');
        var pillText = p.brand === 'Pokémon' ? '#3a1414' : (p.brand === 'One Piece' ? '#0e3940' : '#fff');
        return '<a class="pc-search__result" href="/products/' + p.id + '">' +
          '<div class="pc-search__result-thumb">' +
            '<img src="' + p.thumb + '" alt="" style="transform: scale(' + (p.thumbScale || 1) + ');" />' +
          '</div>' +
          '<div class="pc-search__result-info">' +
            '<span class="pc-search__result-pill" style="background:' + pillBg + ';color:' + pillText + ';">' + escapeHtml(p.brand) + '</span>' +
            '<div class="pc-search__result-name">' + escapeHtml(p.name) + '</div>' +
            '<div class="pc-search__result-subtitle">ACRYLIC CASE</div>' +
          '</div>' +
          '<div class="pc-search__result-price">$' + p.price + '</div>' +
        '</a>';
      }).join('');
    }

    input.addEventListener('input', render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

  // ----------------------------------------------------------
  // SHOP link → direct jump to #shop without the "top-then-scroll"
  // browser flash. Two paths:
  //  - Same page (on home): preventDefault + scrollIntoView. No nav.
  //  - Cross-page (PDP/About/etc.): navigate to / and on next page load,
  //    immediately scroll to #shop on DOMContentLoaded.
  // ----------------------------------------------------------
  function initShopJump() {
    function scrollToShop(instant) {
      var t = document.getElementById('shop');
      if (!t) return false;
      t.scrollIntoView({ behavior: instant ? 'auto' : 'auto', block: 'start' });
      return true;
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/(^|\/)#shop$|#shop$/.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      var samePage = url.pathname === location.pathname && url.host === location.host;
      if (samePage) {
        e.preventDefault();
        if (scrollToShop(true)) {
          history.replaceState(null, '', '#shop');
        }
      }
      // else: let browser navigate; the DOMContentLoaded handler below will
      // jump straight to #shop without showing the top first.
    });

    if (location.hash === '#shop') {
      // Run as early as possible — before paint when feasible.
      scrollToShop(true);
      // Also try after DOMContentLoaded in case #shop wasn't in the DOM yet.
      document.addEventListener('DOMContentLoaded', function () { scrollToShop(true); });
    }
  }
  initShopJump();
})();
